const COLOUR_MAP = {
  darkMode: { icon: 'michael', background: 'black' },
  default: { icon: 'aqua', background: 'white' }
};


function getDarkModeImageProps({ darkMode } = {}) {
  return darkMode ? COLOUR_MAP.darkMode : COLOUR_MAP.default;
}

export default getDarkModeImageProps;